import { render, staticRenderFns } from "./sharepwa.vue?vue&type=template&id=60dbd789&scoped=true&"
import script from "./sharepwa.vue?vue&type=script&lang=js&"
export * from "./sharepwa.vue?vue&type=script&lang=js&"
import style0 from "./sharepwa.vue?vue&type=style&index=0&id=60dbd789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbd789",
  null
  
)

export default component.exports